import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { from, Observable } from "rxjs";
import { AuthenticationService } from "../service";

@Injectable()
export class UserAuditRequestInterceptor implements HttpInterceptor {
	constructor(private authenticationService: AuthenticationService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return from(this.handleAccess(request, next));
	}

	userID: string;

	private async handleAccess(request: HttpRequest<unknown>, next: HttpHandler): Promise<HttpEvent<unknown>> {
		this.authenticationService.getCurrentUserValue().subscribe((currentUser: { ID: string }) => {
			this.userID = currentUser.ID;
		});

		// Only add to known domain(s)
		if (
			request.urlWithParams.indexOf("childrenshospitals.org/websvc") > -1 &&
			(request.method == "POST" || request.method == "PUT" || request.method == "DELETE")
		) {
			request = request.clone({
				setParams: {
					editorID: this.userID
				}
			});
		}
		return next.handle(request).toPromise();
	}
}
